module.exports = __webpack_public_path__ + "static/img/bg-ar.0b8d452b.png";